import { SET_SNACK, SET_SNACK_INFO, SET_USER_DETAILS,SET_ROUTE_ACCESS } from "./types";
import HttpService from "../../services/httpService";
import { clearDenialLog } from "../../utils/routeAccess";
export const setUserDetails = (data) => async dispatch => {
  try {
    dispatch({ type: SET_USER_DETAILS, payload: data })
  } catch (error) {
    console.error(error);
    dispatch({ type: SET_SNACK, payload: true })
    dispatch({ type: SET_SNACK_INFO, payload: { msg: error.response.data, snackSeverity: "error" } })

  }
}

export const fetchRouteAccess = () => async dispatch => {
  dispatch({ type: SET_ROUTE_ACCESS, payload: { status: 'loading' } })
  try {
    const response = await HttpService.getMyRouteAccess()
    const data = response.data || {}
    dispatch({
      type: SET_ROUTE_ACCESS,
      payload: {
        status: 'ready',
        paths: data.paths || [],
        fullAccess: data.fullAccess === true,
        settings: data.settings || {},
        loadedAt: new Date().toISOString()
      }
    })
  } catch (error) {
    console.error('Could not load route access', error)
    dispatch({ type: SET_ROUTE_ACCESS, payload: { status: 'error' } })
  }
}

export const clearRouteAccess = () => dispatch => {
  clearDenialLog()
  dispatch({ type: SET_ROUTE_ACCESS, payload: { status: 'idle', paths: null, fullAccess: false, loadedAt: null } })
}